// src/pages/Wallet.tsx
import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useGetWalletSessionMutation } from "../services/api/walletApi";

const Wallet: React.FC = () => {
  const [getWalletSession, { data, isLoading, error, isUninitialized }] =
    useGetWalletSessionMutation();

  useEffect(() => {
    getWalletSession();
  }, [getWalletSession]);

  // Una vez obtenido el token, configuramos la comunicación postMessage
  useEffect(() => {
    // Solo agregamos el listener si ya tenemos tokenData
    if (!data) return;
    console.log("DATA", data);
    const handleMessage = (event: MessageEvent) => {
      // Validar que el origen sea el esperado, según la documentación:
      if (event.origin !== "https://flobi-stg.wibond.co") return;
      if (event.data && event.data.action === "requestToken") {
        // Enviamos el token al iframe
        event.source?.postMessage(
          { action: "deliverToken", authData: data },
          { targetOrigin: event.origin }
        );
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [data]);

  if (isLoading || isUninitialized) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 64px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography color="error">
          Error al obtener el token de sesión.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "calc(100vh - 64px)" }}>
      <iframe
        title="Flobi Pay"
        src="https://flobi-stg.wibond.co/"
        frameBorder="0"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </Box>
  );
};

export default Wallet;
